import { FetchNewSupportCallProps, IAllowedDn, IAllowedDnListResponse, IDnResponse, IGetIPagedSelectProps, IPagedSelectResponse, ISubtopicData } from "../models/newSupportCall";
import ApiService from "../services/api";

export const createNewSupportCallFetch = async (body: FetchNewSupportCallProps): Promise<any> => {
  const apiService = new ApiService(import.meta.env.VITE_API_URL, 'api/v1/tas');
	const url = `/tas-occurrences`;

  try {
    // Format DN attribute to be sent as a dnDescription
    const { dn, ...rest } = body;
    const formattedBody = { ...rest, dnDescription: dn };

    const response = await apiService.post<any>(url, formattedBody, {
      headers: {
        "Content-Type": "application/json",
      },
    });

		return response.data;

  } catch (error) {
    console.error("Erro ao criar nova solicitação:", error);
    return null;
  }
};

export const fetchSupportRegionals = async ({ page, size }: IGetIPagedSelectProps): Promise<IPagedSelectResponse | null> => {
    const apiService = new ApiService(import.meta.env.VITE_API_URL, 'api/v1/tas');

    const url = `/support/regionals?page=${page}&size=${size}`;

    try {
      const response = await apiService.get<any>(url);
      
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
}

export const fetchSubtopicsBySubject = async (subjectEnum: string): Promise<ISubtopicData[] | null> => {
    const apiService = new ApiService(import.meta.env.VITE_API_URL, 'api/v1/tas');

    const url = `/support/subjects/${subjectEnum}/subtopics`;

    try {
      const response = await apiService.get<any>(url);
      
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
}

export const fetchSupportOccurrenceOrigins = async ({ page, size }: IGetIPagedSelectProps): Promise<IPagedSelectResponse | null> => {
    const apiService = new ApiService(import.meta.env.VITE_API_URL, 'api/v1/tas');

    const url = `/support/occurrence-origins?page=${page}&size=${size}`;

    try {
      const response = await apiService.get<any>(url);
      
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
}

export const fetchDnsOptions = async (): Promise<IAllowedDnListResponse | null> => {
    const apiService = new ApiService();

    const url = `users/consultants/allowed-dn-list`;

    try {
      const response = await apiService.get<IAllowedDnListResponse>(url);
      
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
}

export const fetchAllDnsBySearch = async (name: string): Promise<IDnResponse[] | null> => {
    const apiService = new ApiService();

    const url = `dealerships?name=${name}&dn=${name}`;

    try {
      const response = await apiService.get<any>(url);
      
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
}


